import React from 'react';
import clsx from 'clsx';
import styles from './LoadingSpinner.module.css';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', className }) => {
  return (
    <output
      className={clsx(
        styles.spinner,
        {
          [styles.spinnerSmall]: size === 'small',
          [styles.spinnerMedium]: size === 'medium',
          [styles.spinnerLarge]: size === 'large'
        },
        className
      )}
      aria-label="Loading"
    />
  );
};

export default LoadingSpinner;
